// Assign Designer and Developer (per sample round) — the screen's strings in the portal's four languages (2026-10-21).
// Shown both on the public ticket reply page and on /development/assign/<group>.
const en = {
  title: 'Assign Designer and Developer',
  failed: 'Failed ({{status}})',
  loading: 'Loading the project…',
  notOnList: '{{name}} (not on the list)',
  note: 'The names picked here are written onto the Sample IDs below, which were created when the SKU was approved. Leaving a box empty clears the name.',
  noSample: 'No sample has been created for this project yet.',
  designer: 'Designer',
  developer: 'Developer',
  noSampleOn: 'No sample yet on: {{list}}',
  savedN: '✓ Saved {{n}} sample(s)',
  saving: 'Saving…',
  saveN: 'Save {{n}} change(s)',
  save: 'Save',
};

const ko = {
  title: '디자이너 및 개발자 지정',
  failed: '실패 ({{status}})',
  loading: '프로젝트를 불러오는 중…',
  notOnList: '{{name}} (목록에 없음)',
  note: '여기서 고른 이름은 아래 Sample ID에 기록됩니다. Sample ID는 SKU가 승인될 때 생성되었습니다. 칸을 비워 두면 이름이 지워집니다.',
  noSample: '이 프로젝트에는 아직 생성된 샘플이 없습니다.',
  designer: '디자이너',
  developer: '개발자',
  noSampleOn: '아직 샘플 없음: {{list}}',
  savedN: '✓ 샘플 {{n}}개 저장됨',
  saving: '저장 중…',
  saveN: '변경 {{n}}건 저장',
  save: '저장',
};

const vi = {
  title: 'Phân công Designer và Developer',
  failed: 'Thất bại ({{status}})',
  loading: 'Đang tải dự án…',
  notOnList: '{{name}} (không có trong danh sách)',
  note: 'Tên chọn ở đây được ghi vào các Sample ID bên dưới, vốn được tạo khi SKU được duyệt. Để trống một ô thì tên sẽ bị xóa.',
  noSample: 'Dự án này chưa có mẫu nào được tạo.',
  designer: 'Designer',
  developer: 'Developer',
  noSampleOn: 'Chưa có mẫu: {{list}}',
  savedN: '✓ Đã lưu {{n}} mẫu',
  saving: 'Đang lưu…',
  saveN: 'Lưu {{n}} thay đổi',
  save: 'Lưu',
};

const zh = {
  title: '指派设计师和开发员',
  failed: '失败（{{status}}）',
  loading: '正在加载项目…',
  notOnList: '{{name}}（不在列表中）',
  note: '此处选择的姓名会写入下方的 Sample ID，这些 Sample ID 是在 SKU 获批时创建的。留空则清除姓名。',
  noSample: '此项目还没有创建样品。',
  designer: '设计师',
  developer: '开发员',
  noSampleOn: '尚无样品：{{list}}',
  savedN: '✓ 已保存 {{n}} 个样品',
  saving: '保存中…',
  saveN: '保存 {{n}} 项更改',
  save: '保存',
};

const dictionary = { ns: 'xAssign', en, ko, vi, zh };

export default dictionary;
